import { useTranslation } from "react-i18next";
import LogoOrange from "../assets/logo-orange";
import LogoStripe from "../assets/logo-stripe";

function Home() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="flex flex-col items-center gap-2">
        <LogoOrange width={200} height={50} />
        <div className="flex items-center text-sm text-gray-400">
          <span>{t("home.powered_by")}</span>
          <LogoStripe width={60} height={25} />
        </div>
      </div>
    </div>
  );
}

export default Home;
